import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import FsTabPanel from 'ui-elements/tabs/FsTabPanel';
import NotificationSettings from './NotificationSettings';
import { notificationSettingsProps, tabs } from './Settings.utils';
import UsersManagement from './UsersManagement';

const Settings: React.FC = () => {
  const [idx, setIdx] = useState<number>(0);
  const notificationStatus = idx === 0;
  const usersManagementStatus = idx === 1;

  return (
    <>
      <Box marginBottom={4}>
        <FsTabPanel
          labels={tabs}
          onChange={(_, newValue) => setIdx(newValue)}
          value={idx}
        />
      </Box>
      {notificationStatus && (
        <NotificationSettings
          {...notificationSettingsProps}
          inStatus={notificationStatus}
        />
      )}
      {usersManagementStatus && (
        <UsersManagement inStatus={usersManagementStatus} />
      )}
    </>
  );
};

export default Settings;
